import { DatabaseService, Invoice, InvoiceData, InvoiceRepository } from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getInvoiceRepository(
  databaseService: DatabaseService,
): InvoiceRepository {
  return getGenericRepository<Invoice, InvoiceData>(
    () => DatabaseCollection.INVOICES,
    databaseService,
  );
}
